import React, { useEffect } from 'react';
import proptypes from 'prop-types';
const { string, func, bool } = proptypes;
import { useDataModel } from '@thd-nucleus/data-sources';
import { CtaSection } from '../common/CtaSection';
import { buildSamLink } from '../../utils/home-services-cta-utils';
import { dataModel } from './dataModel';

const GccCarpetSamCta = ({
  itemId, onClick, target, hideLabel, isFooter
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('schedule-a-measure.ready'); }, []);

  const { data } = useDataModel('product', {
    skip: !itemId,
    ssr: true,
    variables: {
      itemId
    }
  });

  if (!itemId) {
    return null;
  }

  const {
    product: {
      identifiers: {
        specialOrderSku,
        storeSkuNumber
      } = {}
    } = {}
  } = data || {};

  return (
    <CtaSection
      buttonText="Schedule a Measure"
      buttonLink={buildSamLink(specialOrderSku || storeSkuNumber)}
      isFooter={isFooter}
      openContentInDrawer
      onClick={onClick}
      label="Get Estimate"
      labelLink={`https://custom.homedepot.com/flooring/${itemId}`}
      hideLabel={hideLabel}
      hideContactInfo
      target={target}
      dataComponent="GccCarpetSamCta"
    />
  );
};

GccCarpetSamCta.displayName = 'GccCarpetSamCta';

GccCarpetSamCta.dataModel = dataModel;

GccCarpetSamCta.propTypes = {
  hideLabel: bool,
  isFooter: bool,
  itemId: string.isRequired,
  onClick: func,
  target: string
};

GccCarpetSamCta.defaultProps = {
  hideLabel: false,
  isFooter: false,
  onClick: () => { },
  target: '_blank'
};

export { GccCarpetSamCta };
